var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_vm._l((_vm.localFiles),function(file){return _c('app-thumbnail-dialog',{key:file.id,attrs:{"file":file},on:{"delete":_vm.deleteFile}})}),_c('app-file-upload',{on:{"input":_vm.addFile}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }